import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";

export default function ZeroQuantityErrorModal({ open, onClose }) {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={onClose}>
      <DialogTitle sx={{ p: 3 }}>
        <Typography align="center" color="error" sx={{ px: 2, fontWeight: 500, fontSize: 22 }}>
          Error
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: "absolute", right: 16, top: 16 }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" pb={2}>
          <Typography
            color="textPrimary"
            align="center"
            sx={{ mb: 2, maxWidth: 500, fontWeight: 500 }}
          >
            One or more items has a received quantity of zero.
          </Typography>
          <Typography color="textPrimary" align="center" sx={{ mb: 2, maxWidth: 500 }}>
            Please input the correct quantity to proceed.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
} 